







































































import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { MassMessage } from "@scrile/api-provider/dist/api/MassMessageProvider";
import { $t } from "@/lib/i18nHelpers";
import { getNow } from "@/lib/time";
import BaseButton from "@/components/BaseButton";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";
import GroupSelectedInformer from "@/components/GroupSelectedInformer";
import MessageEditorView from "@/components/MessageEditorView";
import ScheduledDateView from "@/components/ScheduledDateView";
import SendMessageController from "@/components/SendMessageController";
import MassMessageScheduledOption from "./MassMessageScheduledOption.vue";
import useMassMessage from "../hooks/useMassMessage";

const ADMIN_ID = "1";

export default defineComponent({
  name: "MassMessageEditView",
  components: {
    BaseChip,
    BaseIcon,
    BaseButton,
    ScheduledDateView,
    MessageEditorView,
    SendMessageController,
    GroupSelectedInformer,
    MassMessageScheduledOption,
  },
  props: {
    loading: { type: Boolean, default: false },
    massMessage: { type: Object as () => MassMessage },
    groupIds: { type: Array as () => string[] },
    excludedIds: { type: Array as () => string[] },
    recipientCount: { type: Number, default: 0 },
  },
  setup(props, { emit }) {
    const massMessage = computed(() => props.massMessage);

    const {
      value,
      previewFiles,
      scheduledTime,
      pricePackageId,
      messageEditorRef,
      selectedGroupIds,
      excludedGroupIds,
      allowScheduledMassMessages,
      getNowDate,
      updateAttachmentFiles,
      getMassMessageReadyToSave,
    } = useMassMessage(massMessage);

    const isHasMessageToSend = computed<boolean>(() => !!value.value || previewFiles.value.length > 0);

    const isShowSchedule = ref(false);
    const onDateSave = (date: Date) => {
      scheduledTime.value = date.toISOString();
      isShowSchedule.value = false;
    };
    const onSubmit = debounce(() => emit("submit", getMassMessageReadyToSave()), 200);
    const onCancelScheduledTime = () => (scheduledTime.value = getNowDate());

    const isScheduledMessage = computed<boolean>(() => {
      return new Date(scheduledTime.value).getTime() >= getNow().getTime() + 1000;
    });
    const buttonText = computed(() => (isScheduledMessage.value ? $t("Save") : $t("Send")));

    watch(
      toRef(props, "groupIds"),
      () => {
        if (props.groupIds) selectedGroupIds.value = props.groupIds;
      },
      { immediate: true }
    );
    watch(
      toRef(props, "excludedIds"),
      () => {
        if (props.excludedIds) excludedGroupIds.value = props.excludedIds;
      },
      { immediate: true }
    );

    return {
      value,
      ADMIN_ID,
      buttonText,
      previewFiles,
      scheduledTime,
      pricePackageId,
      isShowSchedule,
      messageEditorRef,
      selectedGroupIds,
      excludedGroupIds,
      isHasMessageToSend,
      allowScheduledMassMessages,
      onSubmit,
      onDateSave,
      onCancelScheduledTime,
      updateAttachmentFiles,
    };
  },
});
